import { GetAllGenericPropsQuery } from "@graphql";
import { Reward, RewardCountry } from "components/pages/GlobalRewards/types";
import { RegionalReward } from "components/atoms/RewardCard";
import { createContext, useContext } from "react";

export type BricksPreloadedPropsContextType = {
  strapiProps?: GetAllGenericPropsQuery;
  rewardProps?: {
    rewardCountries: RewardCountry[];
    initialRewards: Reward[];
    regionalRewards: RegionalReward[];
    rewardRegion: string;
  };
};

/**
 * Context to provide preloaded props for all react bricks
 */
export const BricksPreloadedPropsContext = createContext<
  BricksPreloadedPropsContextType | undefined
>(undefined);

export const useBricksPreloadedProps = () => {
  const context = useContext(BricksPreloadedPropsContext);

  if (!context) {
    return {};
  }

  return context;
};
